import util from '@/utils/index'
import baseMutations from "@/store/mutations";
const mutations = {
    ...baseMutations,
    // 购物车
    cartList(state, params) {
        const data = params.data;
        const perBuyAmount = function(item) {
            const // 限购数量
                perBuyAmount = item.perBuyAmount,
                // 库存
                stock = item.stock;
            if (perBuyAmount == 0) {
                return stock;
            }
            // 如果库存大于限购数量，限购数量为商品限购数量
            // 反之限购数量为最大库存
            return perBuyAmount > stock ? stock : perBuyAmount;
        }
        util.eachList(data, function(item) {
            item.checked = false;
            item.goodsVM.perBuyAmount = perBuyAmount(item.goodsVM);
        });
        state.cartList = data;
    }
}
export default mutations